/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

/* eslint-env browser */
var Cookies = require('js-cookie');

let cookie = {
  set({name, value='', path='/', domain='', expires=''}) {
    Cookies.set(name, value, {path: path, domain: domain, expires: expires});
  },

  unset(name) {
    Cookies.remove(name);
  },

  get(name) {
    return Cookies.get(name);
  }
};

export default cookie;




// WEBPACK FOOTER //
// ./src/helpers/cookie.js